<template>
    <div role="progressbar" class="ProgressBar">
        <div class="ProgressBar-bar ProgressBar-bar--primary">
            <span class="ProgressBar-inner"></span>
        </div>
        <div class="ProgressBar-bar ProgressBar-bar--secondary">
            <span class="ProgressBar-inner"></span>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "ProgressBar"
});
</script>

<style lang="scss" scoped>
.ProgressBar {
    $block: &;
    position: relative;
    width: 100%;
    height: .25rem;
    overflow: hidden;
    background-color: #e6e6e6;
    transition: opacity .24s cubic-bezier(.4,0,.6,1);
    transform: translateY(calc((var(--spaceMd) * -1) + .2em));

    &:not(.is-visible) {
        opacity: 0;
    }

    &-bar {
        position: absolute;
        width: 100%;
        height: 100%;
        transform-origin: top left;

        &--primary {
            left: -145%;
            transform: scaleX(0);
            animation: progress-primary 2s infinite linear;

            #{$block}-inner {
                animation: progress-primary-scale 2s infinite linear;
            }
        }

        &--secondary {
            left: -54.8%;
            animation: progress-secondary 2s infinite linear;

            #{$block}-inner {
                animation: progress-secondary-scale 2s infinite linear;
            }
        }
    }

    &-inner {
        position: absolute;
        width: 100%;
        border-top: .25rem solid var(--colorBrand, #000);
    }
}

@keyframes progress-primary {
    0% {
        transform: translateX(0);
    }
    20% {
        animation-timing-function: cubic-bezier(0.5, 0, 0.701732, 0.495819);
        transform: translateX(0);
    }
    59.15% {
        animation-timing-function: cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);
        transform: translateX(83.67142%);
    }
    100% {
        transform: translateX(200.611057%);
    }
}

@keyframes progress-primary-scale {
    0% {
        transform: scaleX(0.08);
    }
    36.65% {
        animation-timing-function: cubic-bezier(0.334731, 0.12482, 0.785844, 1);
        transform: scaleX(0.08);
    }
    69.15% {
        animation-timing-function: cubic-bezier(0.06, 0.11, 0.6, 1);
        transform: scaleX(0.661479);
    }
    100% {
        transform: scaleX(0.08);
    }
}

@keyframes progress-secondary {
    0% {
        animation-timing-function: cubic-bezier(0.15, 0, 0.515058, 0.409685);
        transform: translateX(0);
    }
    25% {
        animation-timing-function: cubic-bezier(0.31033, 0.284058, 0.8, 0.733712);
        transform: translateX(37.651913%);
    }
    48.35% {
        animation-timing-function: cubic-bezier(0.4, 0.627035, 0.6, 0.902026);
        transform: translateX(84.386165%);
    }
    100% {
        transform: translateX(160.277782%);
    }
}

@keyframes progress-secondary-scale {
    0% {
        animation-timing-function: cubic-bezier(0.205028, 0.057051, 0.57661, 0.453971);
        transform: scaleX(0.08);
    }
    19.15% {
        animation-timing-function: cubic-bezier(0.152313, 0.196432, 0.648374, 1.004315);
        transform: scaleX(0.457104);
    }
    44.15% {
        animation-timing-function: cubic-bezier(0.257759, -0.003163, 0.211762, 1.38179);
        transform: scaleX(0.72796);
    }
    100% {
        transform: scaleX(0.08);
    }
}
</style>